import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useDownloadFile } from 'hooks/useDownloadFile';
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import {
  Action,
  Content,
  SinglePageContent,
  SinglePageStyled,
  Subtitle,
  Title
} from "./DownloadHandler.styled";
import Footer from "../../components/Footer/Default";
import { ROUTES_CORE } from "commons/constants/paths";

const DownloadHandler = () => {
  const { id } = useParams();
  const { downloadFile, loading, error } = useDownloadFile();
  const { t } = useTranslation();
  let navigate = useNavigate();

  useEffect(() => {
    if (id) {
      downloadFile(id);
    }
  }, [id]);

  return (
    <SinglePageStyled>
      <SinglePageContent>
        <Content>
          <Title>{t('Download Manager')}</Title>
          {loading && <Subtitle>{t('Downloading file...')}</Subtitle>}
          {error && <Subtitle>{t('Error while downloading:')} {error}</Subtitle>}
          {!loading && !error && <Subtitle>{t('The file should download automatically.')}</Subtitle>}
          <div>
            <Action onClick={() => navigate(ROUTES_CORE.HOME)}>
              {t('Go to the home page')}
            </Action>
          </div>
        </Content>
      </SinglePageContent>
      <Footer></Footer>
    </SinglePageStyled>);
};

export default DownloadHandler;